<template>
    <div class="bigPlay"
         @mouseenter="$emit('mouseenter')"
         @mouseleave="$emit('mouseleave')"
         @click="clicked"
    >
        <BigPlayIcon />
    </div>
</template>

<script>
    import BigPlayIcon from '@icons/BigPlay';
    import Thumbnail from './Thumbnail';

    export default {
        name: "BigPlay",
        components:{
            BigPlayIcon
        },
        methods:{
            clicked(){
                window.analytics.view();
                this.$emit('click');
            }
        }
    }
</script>

<style scoped>
    .bigPlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: transparent;
        height: 100%;
        cursor: pointer;
    }
</style>T